export const team = [
  {
    id: 0,
    image: "/images/andy-bluebg.png",
    name: "Andy Cary",
    position: "Web Developer",
    authorLink: "https://adroit.andycary.com/",
    authorTitle: "Adroit Development",
    authorDescription:
      "A guide to building, testing and deploying modern systems.",
    paragraph1:
      "Andy Cary is a Senior Software Engineer specializing in building usable, performant, reliable and maintainable web applications. He earned his Master of Science in Engineering from The University of Texas at Austin's Cockrell School of Engineering, with coursework spanning distributed systems, software architecture, and scalable machine learning, and his Bachelor of Science in Information Science from The University of North Carolina at Chapel Hill.",
    paragraph2:
      "He is currently a Senior Software Engineer at The Home Depot (Fortune 20), working on the Pro Order Up platform across frontend, backend, and delivery automation. He previously worked at REI Systems, Inc. building a Java microservices data platform for FEMA, and as a software developer at VidDay Media, Inc. and Stanford University IT.",
  },
];
